<template>
  <div class="flex flex-col h-full bg-white overflow-y-auto pb-10">
    <div class="p-6 border-b border-pink-50 flex items-center gap-4 sticky top-0 bg-white z-10">
      <button @click="$router.back()" class="text-gray-400">←</button>
      <h2 class="text-xl font-black text-gray-800">Editar Perfil</h2>
    </div>

    <div class="p-8 space-y-6">
      <div class="flex flex-col items-center gap-4">
        <div class="relative group">
            <div v-if="form.is_premium"
                class="absolute -top-2 -right-2 z-30 bg-gradient-to-tr from-[#ff2d55] to-[#ff6b8b] p-2 rounded-full shadow-[0_4px_15px_rgba(255,45,85,0.4)] border-2 border-white transform rotate-12 animate-in fade-in zoom-in duration-500">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white" viewBox="0 0 24 24" fill="currentColor">
                <path d="M16 2H8l-5 7 9 13 9-13-5-7zm1.23 8l-1.92 3.51L12 18.09l-3.31-4.58L6.77 10h10.46zM12 4.12L14.77 8H9.23L12 4.12z" />
            </svg>
            </div>
          <div v-if="uploading" class="absolute inset-0 bg-white/80 z-20 flex items-center justify-center rounded-[2.5rem]">
            <div class="animate-spin text-romance-red">⏳</div>
          </div>

          <img :src="form.photo_url || 'https://via.placeholder.com/150?text=Matchi'"
               class="w-36 h-36 rounded-[2.5rem] object-cover shadow-2xl border-4 border-pink-50 transition-all group-hover:brightness-90" />

          <label class="absolute inset-0 flex items-center justify-center bg-black/20 rounded-[2.5rem] opacity-0 group-hover:opacity-100 cursor-pointer transition-all">
            <span class="text-white text-xs font-black uppercase tracking-wider">Cambiar Foto</span>
            <input type="file" @change="uploadToImageKit" class="hidden" accept="image/*" />
          </label>
        </div>
        <p v-if="uploading" class="text-[10px] font-bold text-pink-500 animate-pulse uppercase">Subiendo a la nube...</p>
      </div>

      <div class="space-y-4">
        <div v-if="form.is_premium" class="bg-slate-50 p-5 rounded-[2rem] border border-slate-100 mb-6 shadow-sm">
            <div class="flex items-center gap-4">
                <div class="bg-white p-2.5 rounded-2xl shadow-sm border border-slate-50">
                <span class="text-xl">💎</span>
                </div>
                <div class="flex-1">
                <p class="text-slate-900 text-[13px] font-black leading-tight">
                    Beneficio Premium
                </p>
                <p class="text-slate-500 text-[11px] font-medium leading-relaxed mt-0.5">
                    Tienes activada la mejor experiencia. Las mujeres te pondrán más interés y las pláticas se pondrán más personales.
                </p>
                </div>
            </div>
        </div>
        <div>
          <label class="text-[10px] font-black uppercase text-gray-400 ml-2">Nombre Completo</label>
          <input v-model="form.full_name" type="text" class="input-matchi" />
        </div>

        <div>
          <div class="flex justify-between items-center mb-1">
            <label class="text-[10px] font-black uppercase text-gray-400 ml-2">Fecha de Nacimiento</label>
            <span v-if="edadCalculada"
                  :class="edadCalculada < 18 ? 'text-red-500 animate-bounce' : 'text-romance-red'"
                  class="text-[10px] font-black uppercase mr-2">
              {{ edadCalculada }} años {{ edadCalculada < 18 ? ' (Mínimo 18)' : '' }}
            </span>
          </div>
          <input v-model="form.birth_date" type="date" class="input-matchi" />
        </div>

        <div>
          <label class="text-[10px] font-black uppercase text-gray-400 ml-2">Género</label>
          <select v-model="form.gender" class="select-matchi">
            <option :value="null" disabled>Seleccioná el género</option>
            <option v-for="opt in GENDER_OPTIONS" :key="opt.value" :value="opt.value">
              {{ opt.label }}
            </option>
          </select>
        </div>
        <div>
          <label class="text-[10px] font-black uppercase text-gray-400 ml-2">Me interesa</label>
            <select v-model="form.interested_in" class="select-matchi">
              <option :value="null" disabled>Seleccioná el género</option>
              <option v-for="opt in GENDER_OPTIONS" :key="opt.value" :value="opt.value">
                {{ opt.label }}
              </option>
            </select>
        </div>

        <div>
          <label class="text-[10px] font-black uppercase text-gray-400 ml-2">Ocupación</label>
          <input v-model="form.occupation" type="text" placeholder="¿En qué trabajás maje?" class="input-matchi" />
        </div>

        <div>
          <label class="text-[10px] font-black uppercase text-gray-400 ml-2">Sobre mí (Tu bio)</label>
          <textarea v-model="form.bio" rows="4" placeholder="Contá algo diacachimba para que las chavalas te conozcan..." class="input-matchi resize-none"></textarea>
        </div>
      </div>

      <button @click="saveProfile" :disabled="loading || uploading || (edadCalculada !== null && edadCalculada < 18)"
              class="w-full py-4 bg-romance-red text-white font-black rounded-2xl shadow-xl shadow-blue-200 active:scale-95 transition-all disabled:opacity-50 disabled:grayscale">
        {{ loading ? 'Guardando...' : 'Guardar Cambios' }}
      </button>

      <button @click="handleLogout"
              class="w-full py-4 text-gray-400 font-bold text-sm uppercase tracking-widest hover:text-red-500 transition-colors">
        Cerrar Sesión
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios'
import api from '@/api'
import ImageKit from "imagekit-javascript"
import Swal from 'sweetalert2'
import { GENDER_OPTIONS } from '@/constants/userOptions'

const form = ref({
  full_name: '',
  occupation: '',
  bio: '',
  photo_url: '',
  birth_date: '',
  gender: null,
  interested_in:null,
  is_premium: 0
})

const router  = useRouter()
const loading = ref(false)
const uploading = ref(false)

const edadCalculada = computed(() => {
  if (!form.value.birth_date) return null
  const born = new Date(form.value.birth_date)
  const now = new Date()
  let age = now.getFullYear() - born.getFullYear()
  const monthDiff = now.getMonth() - born.getMonth()

  if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < born.getDate())) {
    age--
  }
  return age
})

const imagekit = new ImageKit({
    publicKey: "public_/3U8FUqBxyOMDp391ussbMblflI=",
    urlEndpoint: "https://ik.imagekit.io/matchiapp",
});

onMounted(async () => {
  const userId = JSON.parse(localStorage.getItem('user')).id
  const res = await api.get(`/users/${userId}`)
  form.value = { ...res.data }
})

const handleLogout = () => {
  Swal.fire({
    title: '¿Te vas?',
    text: "Tendrás que iniciar sesión de nuevo para chatear.",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#2F80ED',
    cancelButtonColor: '#d1d5db',
    confirmButtonText: 'Sí, cerrar sesión',
    cancelButtonText: 'Cancelar',
    customClass: {
        popup: 'rounded-[2rem]',
        confirmButton: 'rounded-xl font-bold uppercase',
        cancelButton: 'rounded-xl font-bold uppercase'
    }
  }).then((result) => {
    if (result.isConfirmed) {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      router.push('/')
    }
  })
}

const uploadToImageKit = async (event) => {
  const file = event.target.files[0];
  if (!file) return;

  uploading.value = true;
  const fileName = `user_id_${JSON.parse(localStorage.getItem('user')).id}_${Date.now()}.jpg`;

  const formData = new FormData();
  formData.append("file", file);
  formData.append("fileName", fileName);
  formData.append("useUniqueFileName", "true");
  formData.append("publicKey", "public_/3U8FUqBxyOMDp391ussbMblflI=");

  try {
    const res = await axios.post("https://upload.imagekit.io/api/v2/files/upload", formData, {
      headers: {
        "Authorization": "Basic cHJpdmF0ZV9CbHNOOTFXQjI4cXhiMHJlZ3c2QkpZQ2RHWDA9Og==",
        "Content-Type": "multipart/form-data"
      }
    });

    const baseUrl = "https://ik.imagekit.io/matchiapp";
    const filePath = res.data.filePath;

    form.value.photo_url = `${baseUrl}${filePath}?tr=w-400,h-400,fo-auto`;

    Swal.fire({
      icon: 'success',
      title: '¡Foto actualizada!',
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      background: '#fff',
      color: '#2F80ED'
    });
  } catch (err) {
    console.error("Error en la subida:", err.response?.data || err);
    Swal.fire({
      icon: 'error',
      title: 'Error al subir',
      text: 'No pudimos guardar tu foto, intentá de nuevo.',
      confirmButtonColor: '#2F80ED'
    });
  } finally {
    uploading.value = false;
  }
};

const saveProfile = async () => {
  if (edadCalculada.value === null) {
    Swal.fire({ icon: 'error', title: 'Falta info', text: 'Por favor poné tu fecha de nacimiento.', confirmButtonColor: '#ec4899' });
    return;
  }

  if (edadCalculada.value < 18) {
    Swal.fire({
      icon: 'error',
      title: 'Edad no permitida',
      text: 'Debes ser mayor de 18 años para usar esta aplicación.',
      confirmButtonColor: '#ff0000'
    });
    return;
  }

  if (form.value.full_name.length < 3) {
    Swal.fire({ icon: 'warning', title: 'Nombre muy corto', text: 'Poné tu nombre completo maje.', confirmButtonColor: '#ec4899' });
    return;
  }

  loading.value = true
  try {
    const userId = JSON.parse(localStorage.getItem('user')).id
    await api.put(`/users/${userId}`, form.value)

    const currentUser = JSON.parse(localStorage.getItem('user'))
    localStorage.setItem('user', JSON.stringify({ ...currentUser, ...form.value }))

    Swal.fire({
      title: '¡Todo listo!',
      text: 'Tu perfil se actualizó correctamente.',
      icon: 'success',
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#2F80ED',
      customClass: {
        popup: 'rounded-[2rem]',
        confirmButton: 'rounded-xl font-black uppercase tracking-widest'
      }
    });
  } catch (err) {
    console.error(err)
    Swal.fire({ icon: 'error', title: 'Error', text: 'No pudimos guardar los cambios. Revisá tu internet.', confirmButtonColor: '#ec4899' });
  } finally {
    loading.value = false
  }
}
</script>